import * as React from 'react';
import { TabCard } from '@cimpress/react-components';
import { UrlArtworkSelector } from './UrlArtworkSelector';
import { FileArtworkSelector } from './FileArtworkSelector';
import { useDoubleTTranslation } from '../hooks/i18n';
export const ArtworkSelector = ({ language, accessToken, onChange, environment, productConfig }) => {
    const [state, setState] = React.useState(undefined);
    const { tt } = useDoubleTTranslation(language);
    React.useEffect(() => onChange(state), [state]);
    const tabs = [
        {
            name: tt('artworkSelector.uploadAFile'),
            block: React.createElement(FileArtworkSelector, { accessToken: accessToken, productConfig: productConfig, onChange: setState, currentSelectorState: state, environment: environment })
        },
        {
            name: tt('artworkSelector.url'),
            block: React.createElement(UrlArtworkSelector, { accessToken: accessToken, onChange: setState, currentSelectorState: state, environment: environment })
        }
    ];
    return React.createElement(TabCard, { tabs: tabs });
};
//# sourceMappingURL=ArtworkSelector.js.map